var React = require('react');

function SurveysInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5067 4.77778H18.2222C19.2041 4.77778 20 5.57372 20 6.55556V19C20 19.9818 19.2041 20.7778 18.2222 20.7778H5.77778C4.79594 20.7778 4 19.9818 4 19V6.55556C4 5.57372 4.79594 4.77778 5.77778 4.77778H9.49333C9.86667 3.74667 10.8444 3 12 3C13.1556 3 14.1333 3.74667 14.5067 4.77778ZM12 4.77778C12.4909 4.77778 12.8889 5.17575 12.8889 5.66667C12.8889 6.15759 12.4909 6.55556 12 6.55556C11.5091 6.55556 11.1111 6.15759 11.1111 5.66667C11.1111 5.17575 11.5091 4.77778 12 4.77778ZM7.55556 10.1111V8.33333H16.4444V10.1111H7.55556ZM7.55556 13.6667V11.8889H16.4444V13.6667H7.55556ZM7.55556 17.2222H13.7778V15.4444H7.55556V17.2222Z"}));
}

SurveysInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"black"};

module.exports = SurveysInline;

SurveysInline.default = SurveysInline;
